<template>
  <span>
    <div class="con-1">
      <span
        :class="{ 'client-span': client.type === 'person' }"
        @click="goToEdit(client.type, client.id)"
        v-html="client.name"
      ></span>
      <a
        @click.prevent="generalShowHide('showDates', client.type + client.id)"
        href="#"
        v-if="
          searchResults &&
            (`${client.type}.${client.id}` in searchResults ||
              client.type === 'other')
        "
      >
        <img src="../../../assets/img/m_calendar.png" alt="Calendar" />
      </a>
      <div
        class="sr-appointments-all"
        v-if="
          showDates.indexOf(client.type + client.id) !== -1 &&
            searchResults[`${client.type}.${client.id}`]
        "
      >
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>

          <!-- For normal clients and other -->
          <tbody v-if="client.type !== 'other'">
            <template
              v-for="appointment in searchResults[
                `${client.type}.${client.id}`
              ]"
            >
              <appointment-result
                :key="appointment.id"
                :id="appointment.id"
                :app_date="appointment.app_date"
                :app_start_hh="appointment.app_start_hh"
                :app_start_mm="appointment.app_start_mm"
                :app_start_tt="appointment.app_start_tt"
                :timezone="appointment.timezone"
                :prevent-remove-results="preventRemoveResults"
              />
            </template>
          </tbody>

          <!-- For others -->
          <tbody v-else>
            <appointment-result
              :id="client.id"
              :app_date="client.app_date"
              :app_start_hh="client.app_start_hh"
              :app_start_mm="client.app_start_mm"
              :app_start_tt="client.app_start_tt"
              :timezone="client.timezone"
              :prevent-remove-results="preventRemoveResults"
            />
          </tbody>
        </table>
      </div>
    </div>
    <div class="con-2">
      <a
        href="#"
        v-if="
          client.type !== 'event_appointment' &&
            client.type !== 'group_appointment' &&
            client.phone.length > 0
        "
        @click.prevent="
          generalShowHide('showChatAndCall', client.type + client.id)
        "
      >
        <span v-if="client.selected_phone !== null">{{
          client.selected_phone
        }}</span>
        <span v-else>{{ client.phone[0] }}</span>
      </a>
      <div
        class="phone-features"
        v-if="showChatAndCall.indexOf(client.type + client.id) !== -1"
      >
        <a
          :href="`tel:${client.selected_phone}`"
          v-if="client.selected_phone !== null"
        >
          <img src="../../../assets/img/m_phone.png" alt="Phone" />
        </a>
        <a :href="`tel:${client.phone[0]}`" v-else>
          <img src="../../../assets/img/m_phone.png" alt="Phone" />
        </a>
        <a
          href="#"
          @click.prevent="goToChat(client.user_id)"
          v-if="client.user_id !== 0"
        >
          <img src="../../../assets/img/m_chat.png" alt="Phone" />
        </a>
      </div>
    </div>
  </span>
</template>

<script>
import AppointmentResult from "./AppointmentResult";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  props: {
    client: Object
  },
  data() {
    return {
      showDates: [],
      showChatAndCall: []
    };
  },
  methods: {
    ...mapMutations("chat", {
      setSelectedUserId: "setSelectedUserId"
    }),
    ...mapMutations({
      preventRemoveResults: "preventRemoveResults"
    }),
    ...mapActions("clients", {
      editClient: "editClient"
    }),
    generalShowHide(key, value) {
      if (this[key].indexOf(value) === -1) {
        this[key] = [...this[key], value];
      } else {
        this[key] = this[key].filter(curValue => {
          return curValue !== value;
        });
      }
    },
    goToChat(value) {
      this.preventRemoveResults();
      this.setSelectedUserId(parseInt(value));
      this.$router.push("/messenger");
    },
    goToEdit(type, clientId) {
      if (type === "person") {
        this.preventRemoveResults();
        this.editClient(clientId);
        this.$router.push("/add_client");
      }
    }
  },
  computed: {
    ...mapGetters({
      searchResults: "getSearchResults"
    })
  },
  components: {
    AppointmentResult // Individual appointment result row
  }
};
</script>

<style scoped>
span.client-span {
  color: #e56700;
}

.sr-appointments-all {
  margin: 10px auto;
  width: 96%;
  min-width: 240px;
}

.sr-appointments-all table {
  color: #e56700;
  text-align: left;
  border: 1px solid #ebebeb;
}

.sr-appointments-all >>> table td,
.sr-appointments-all >>> table th {
  text-align: left;
  padding: 5px;
  color: #000;
  border-bottom: 1px solid #ebebeb;
}

.sr-appointments-all >>> table th {
  color: #000;
  font-weight: bold;
  background: #f8f8f8;
  border-bottom: none;
}

.sr-appointments-all >>> td.appt-time {
  text-align: right;
}
</style>
